import {useTheme} from '@dropbox/dig-foundations';
import {analyticsLogger} from 'analytics/analyticsLogger';
import comingSoonPng from 'assets/images/construction-coming-soon.png';
import comingSoonDarkPng from 'assets/images/construction-coming-soon-dark.png';
import crewDigGif from 'assets/images/construction-crew-dig.gif';
import crewJackhammersGif from 'assets/images/construction-crew-jackhammers.gif';
import crewSledgehammerGif from 'assets/images/construction-crew-sledgehammer.gif';
import crewSonicGif from 'assets/images/construction-crew-sonic.gif';
import lemmingsGif from 'assets/images/construction-lemmings.gif';
import {useEffect, useRef} from 'react';

import styles from './ConstructionCrew.module.css';

const COMING_SOON = 'New name, new look, new experience coming soon';

// All 241x30 strips sharing the same warning sign; one is picked per page load.
const CREWS = [lemmingsGif, crewSledgehammerGif, crewSonicGif, crewDigGif, crewJackhammersGif];
const crewGif = CREWS[Math.floor(Math.random() * CREWS.length)];

// Long enough that passing over the logo doesn't count.
const HOVER_DWELL_MS = 600;

// Once per page load, not per mount.
let hoverLogged = false;

export const ConstructionCrew = () => {
  const {mode} = useTheme();
  const dwellTimer = useRef<ReturnType<typeof setTimeout>>();

  const cancelDwell = () => clearTimeout(dwellTimer.current);

  const startDwell = () => {
    if (hoverLogged) {
      return;
    }
    cancelDwell();
    dwellTimer.current = setTimeout(() => {
      hoverLogged = true;
      analyticsLogger().logEvent('CONSTRUCTION_CREW_HOVERED');
    }, HOVER_DWELL_MS);
  };

  useEffect(() => cancelDwell, []);

  return (
    <span className={styles.crew} onMouseEnter={startDwell} onMouseLeave={cancelDwell}>
      <img src={crewGif} alt="" width={241} height={30} className={styles.workers} />
      <img
        src={mode === 'dark' ? comingSoonDarkPng : comingSoonPng}
        alt={COMING_SOON}
        width={182}
        height={5}
        className={styles.message}
      />
    </span>
  );
};
